export default __webpack_public_path__ + "static/pythone-904e9dfa075b59328d445be8aca046ad.png";